import { useQuery } from '@tanstack/react-query'
import { getSessionIdFromLocalStorage } from 'src/localStorage/sessionId/getSessionIdFromLocalStorage/getSessionIdFromLocalStorage'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'

export interface AdsLibraryPage {
  category?: string
  fan_count?: number
  id: string
  name?: string
  picture?: { data?: { url?: string } }
  verification_status?: string
}

interface SearchPagesResponse {
  data?: AdsLibraryPage[]
  success?: boolean
}

const searchAdsLibraryPages = async (
  q: string
): Promise<SearchPagesResponse | null> => {
  const sessionId = getSessionIdFromLocalStorage()
  if (!sessionId || !q.trim()) return null

  const { data } = await analyticsApi().get<SearchPagesResponse>(
    '/v1_private/ads-library/pages/search',
    { params: { q } }
  )
  return data
}

export const useSearchAdsLibraryPagesQuery = (q: string) => {
  const sessionId = getSessionIdFromLocalStorage()

  return useQuery({
    enabled: !!sessionId && q.trim().length > 1,
    queryFn: () => searchAdsLibraryPages(q),
    queryKey: [QueryKey.GET_ADS_LIBRARY_PAGES_SEARCH, q],
  })
}
